<template>
    <v-container fluid>
        <loading v-model="loading" />
        <!-- TITOLO -->
        <v-row>
            <v-col cols="12">
                <h1 class="pt-16 text-center">modifica coordinate</h1>
            </v-col>
        </v-row>
        <v-card class="overflow-hidden" color="primary" dark>
            <v-toolbar color="primary darken-1">
                <a @click="$router.go(-1)">
                    <v-icon class="mr-3 ml-4">arrow_back</v-icon>
                </a>
                <v-spacer></v-spacer>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="saveCoordinates" :disabled="loading">salva</v-btn>
                    <v-btn color="error" @click="$router.go(-1)" :disabled="loading">annulla</v-btn>
                </v-card-actions>
            </v-toolbar>

            <v-card-text>
                <v-row class="pa-4">
                    <!-- Regione (readonly, si aggiorna con la provincia) -->
                    <v-col cols="12" sm="3">
                        <v-text-field v-model="cityData.region" label="Regione" outlined readonly></v-text-field>
                    </v-col>

                    <!-- Provincia (autocomplete) -->
                    <v-col cols="12" sm="3">
                        <v-autocomplete
                            v-model="selectedProvince"
                            :items="provinces"
                            :loading="loadingProvinces"
                            :search-input.sync="searchProvince"
                            item-text="name"
                            item-value="id"
                            label="Provincia"
                            outlined
                            return-object
                            hide-no-data
                            @change="onProvinceChange"
                        ></v-autocomplete>
                    </v-col>

                    <!-- Città (editabile) -->
                    <v-col cols="12" sm="3">
                        <v-text-field v-model="cityData.city" label="Città" outlined></v-text-field>
                    </v-col>

                    <!-- CAP (gestione array con chip) -->
                    <v-col cols="12" sm="3">
                        <v-card outlined class="pa-2">
                            <v-card-subtitle class="pa-0 mb-2">CAP</v-card-subtitle>
                            <v-row no-gutters align="center">
                                <v-col cols="8">
                                    <v-text-field
                                        v-model="newCap"
                                        label="Aggiungi CAP"
                                        dense
                                        outlined
                                        hide-details
                                        @keyup.enter="addCap"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4" class="pl-2">
                                    <v-btn color="success" small :disabled="!newCap" @click="addCap">
                                        <v-icon small>add</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-chip-group column class="mt-2">
                                <v-chip
                                    v-for="(cap, index) in cityData.caps"
                                    :key="'cap-' + index"
                                    color="primary"
                                    text-color="white"
                                    small
                                    close
                                    @click:close="removeCap(index)"
                                >
                                    {{ cap }}
                                </v-chip>
                                <v-chip v-if="!cityData.caps || cityData.caps.length === 0" color="grey lighten-1" text-color="white" small>
                                    Nessun CAP
                                </v-chip>
                            </v-chip-group>
                        </v-card>
                    </v-col>
                    <!-- Sinonimi provicia -->
                    <v-col cols="12" sm="6">
                        <v-card outlined>
                            <v-card-title class="subtitle-1">sinonimi-provincia</v-card-title>
                            <v-card-text>
                                <!-- Input per aggiungere nuovi Sinonimi -->
                                <v-form @submit.prevent="addProvinceSynonym">
                                    <v-row>
                                        <v-col cols="8">
                                            <v-text-field v-model="newProvinceSynonym" label="Aggiungi sinonimo" outlined dense></v-text-field>
                                        </v-col>
                                        <v-col cols="4" class="d-flex align-center">
                                            <v-btn color="success" small :disabled="!newProvinceSynonym" @click="addProvinceSynonym">
                                                <v-icon left>add</v-icon>
                                                Aggiungi
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <!-- Chip per visualizzare i Sinonimi esistenti con opzione per rimuoverli -->
                                <v-chip-group column>
                                    <v-chip
                                        v-for="(synonym, index) in provinceSynonyms"
                                        :key="'prov-syn-' + index + '-' + provinceForceRenderKey"
                                        color="primary"
                                        text-color="white"
                                        close
                                        @click:close="removeProvinceSynonym(index)"
                                    >
                                        {{ synonym }}
                                    </v-chip>
                                    <v-chip v-if="!provinceSynonyms || provinceSynonyms.length === 0" color="grey lighten-1" text-color="white" small>
                                        Nessun sinonimo
                                    </v-chip>
                                </v-chip-group>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <!-- Sinonimi città -->
                    <v-col cols="12" sm="6">
                        <v-card outlined>
                            <v-card-title class="subtitle-1">Sinonimi città</v-card-title>
                            <v-card-text>
                                <!-- Input per aggiungere nuovi Sinonimi -->
                                <v-form @submit.prevent="addCitySynonym">
                                    <v-row>
                                        <v-col cols="8">
                                            <v-text-field v-model="newCitySynonym" label="Aggiungi sinonimo" outlined dense></v-text-field>
                                        </v-col>
                                        <v-col cols="4" class="d-flex align-center">
                                            <v-btn color="success" small :disabled="!newCitySynonym" @click="addCitySynonym">
                                                <v-icon left>add</v-icon>
                                                Aggiungi
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <!-- Chip per visualizzare i Sinonimi esistenti con opzione per rimuoverli -->
                                <v-chip-group column>
                                    <v-chip
                                        v-for="(synonym, index) in cityData.synonym"
                                        :key="'syn-' + index + '-' + forceCityForceRenderKey"
                                        color="primary"
                                        text-color="white"
                                        close
                                        @click:close="removeCitySinonim(index)"
                                    >
                                        {{ synonym }}
                                    </v-chip>
                                    <v-chip v-if="!cityData.synonym || cityData.synonym.length === 0" color="grey lighten-1" text-color="white" small>
                                        Nessun sinonimo
                                    </v-chip>
                                </v-chip-group>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <!-- Pannello coordinate provincia -->
                    <v-col cols="12" sm="6">
                        <v-card height="100%" class="mx-auto">
                            <v-app-bar dark color="black">
                                <v-card-title>Coordinate provincia</v-card-title>
                                <v-spacer></v-spacer>
                            </v-app-bar>

                            <v-card-text>
                                <v-text-field v-model="provinceData.latitude" label="Latitudine" class="mt-4" outlined></v-text-field>

                                <v-text-field v-model="provinceData.longitude" label="Longitudine" class="mt-4" outlined></v-text-field>

                                <v-btn color="primary" block class="mt-4" @click="updateProvinceCoordinate"> Ottieni coordinate </v-btn>

                                <v-alert v-if="error" type="error" class="mt-4">
                                    {{ error }}
                                </v-alert>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <!-- Pannello coordinate città -->
                    <v-col cols="12" sm="6">
                        <v-card height="100%" class="mx-auto">
                            <v-app-bar dark color="black">
                                <v-card-title>Coordinate città</v-card-title>
                                <v-spacer></v-spacer>
                            </v-app-bar>

                            <v-card-text>
                                <v-text-field v-model="cityData.latitude" label="Latitudine" class="mt-4" outlined></v-text-field>

                                <v-text-field v-model="cityData.longitude" label="Longitudine" class="mt-4" outlined></v-text-field>

                                <v-btn color="primary" block class="mt-4" @click="updateCityCoordinate"> Ottieni coordinate </v-btn>

                                <v-alert v-if="error" type="error" class="mt-4">
                                    {{ error }}
                                </v-alert>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row> </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import loading from '@/components/loading.vue'

export default {
    name: 'CityCoordinateDetail',
    components: {
        loading
    },
    data() {
        return {
            loading: false,
            error: null,
            cityData: {
                id: null,
                city: '',
                province: '',
                region: '',
                caps: [],
                synonym: [],
                latitude: null,
                longitude: null,
                provinceId: null
            },
            provinceData: {
                latitude: null,
                longitude: null
            },

            // Autocomplete province
            provinces: [],
            selectedProvince: null,
            searchProvince: '',
            loadingProvinces: false,

            // CAP
            newCap: '',

            // Sinonimi provincia
            provinceSynonyms: [],
            newProvinceSynonym: '',
            provinceForceRenderKey: 0,
            // Sinonimi città
            newCitySynonym: '',
            forceCityForceRenderKey: 0
        }
    },

    async created() {
        if (this.$route.params.id) {
            await this.getCityData(this.$route.params.id)
        } else {
            this.$router.push('/admin/updateCoordinates')
        }
    },
    watch: {
        searchProvince(val) {
            if (val && val.length >= 2) {
                this.searchProvinces(val)
            }
        }
    },
    computed: {
        //rimozione sinonimi reattiva
        synonyms() {
            return [...this.cityData.synonym]
        },
        countryName() {
            const countryMap = { it: 'Italy', es: 'Spain' }
            return countryMap[this.$i18n.locale] || 'Italy'
        }
    },
    methods: {
        async getCityData(id) {
            this.loading = true
            try {
                const response = await this.$http.get(`cities/${id}`, {
                    populate: ['Province', 'Province.synonym', 'synonym']
                })

                const cityData = response.data

                // Estratti i dati dalla risposta
                this.cityData = {
                    id: cityData.id,
                    city: cityData.attributes.Name,
                    province: cityData.attributes.Province.data.attributes.Name,
                    provinceId: cityData.attributes.Province.data.id,
                    region: cityData.attributes.Province.data.attributes.Regione,
                    caps: cityData.attributes.Cap || [],
                    latitude: cityData.attributes.latitude,
                    longitude: cityData.attributes.longitude,
                    synonym: []
                }

                // Inizializza selectedProvince per l'autocomplete
                this.selectedProvince = {
                    id: cityData.attributes.Province.data.id,
                    name: cityData.attributes.Province.data.attributes.Name,
                    region: cityData.attributes.Province.data.attributes.Regione
                }
                // Aggiungi la provincia corrente alla lista per visualizzarla
                this.provinces = [this.selectedProvince]

                console.log(cityData)

                // Coordinate della provincia
                this.provinceData = {
                    latitude: cityData.attributes.Province.data.attributes.latitude || null,
                    longitude: cityData.attributes.Province.data.attributes.longitude || null
                }

                // Gestione dei sinonimi citta
                if (cityData.attributes.synonym && cityData.attributes.synonym.length > 0) {
                    this.cityData.synonym = cityData.attributes.synonym.map((s) => s.Name || '').filter(Boolean)
                } else {
                    this.cityData.synonym = []
                }

                // Gestione dei sinonimi provincia
                if (cityData.attributes.Province.data.attributes.synonym && cityData.attributes.Province.data.attributes.synonym.length > 0) {
                    this.provinceSynonyms = cityData.attributes.Province.data.attributes.synonym.map((s) => s.Name || '').filter(Boolean)
                } else {
                    this.provinceSynonyms = []
                }
                //console.log(response, this.provinceSynonyms, 'synonym ')
            } catch (error) {
                console.error('Errore nel caricamento dei dati della città:', error)
                this.error = 'Errore nel caricamento dei dati. Riprova più tardi.'
            } finally {
                this.loading = false
            }
        },

        /**
         * Recupera le coordinate geografiche dalla API esterna
         * Utilizza i dati della città corrente per ottenere le coordinate
         */
        async updateCityCoordinate() {
            this.loading = true
            this.error = null

            try {
                const requestData = {
                    cap: this.cityData.caps[0] || '',
                    city: this.cityData.city,
                    province: this.cityData.province,
                    country: this.countryName
                }
                console.log('--- CITY COORDINATE REQUEST ---')
                console.log('Dati inviati a Google:', JSON.stringify(requestData, null, 2))
                console.log('Stringa che Google riceverà:', [requestData.cap, requestData.city, requestData.province, requestData.country].filter(p => p && p.trim() !== '').join(' '))

                const res = await this.$http.post(`location`, {
                    type: 'addr',
                    data: requestData
                })

                console.log('Risposta da Google:', JSON.stringify(res, null, 2))

                if (res?.status == 'OK') {
                    console.log(`Coordinate trovate: lat=${res.result.lat}, lng=${res.result.lng}`)
                    this.cityData.latitude = res.result.lat.toString()
                    this.cityData.longitude = res.result.lng.toString()

                    this.$notify({
                        group: 'notifica',
                        title: 'Successo',
                        text: 'Coordinate aggiornate con successo',
                        type: 'success'
                    })
                } else {
                    this.error = "Coordinate non trovate. Controlla l'indirizzo."
                }
            } catch (error) {
                console.error('Errore nel recupero delle coordinate:', error)
                this.error = 'Errore nel recupero delle coordinate. Riprova più tardi.'
            } finally {
                this.loading = false
            }
        },

        /**
         * Salva le coordinate modificate nel database
         * Verifica che entrambe le coordinate siano presenti
         */
        async saveCoordinates() {
            if (!this.cityData.latitude || !this.cityData.longitude) {
                this.error = 'Inserisci entrambe le coordinate prima di salvare.'
                return
            }

            this.loading = true
            try {
                // Preparazione dei sinonimi nel formato corretto per un componente ripetibile
                const citySynonymData = this.cityData.synonym.map((name) => {
                    return {
                        Name: name
                    }
                })

                const updateCityData = {
                    data: {
                        Name: this.cityData.city,
                        latitude: this.cityData.latitude,
                        longitude: this.cityData.longitude,
                        Cap: this.cityData.caps,
                        synonym: citySynonymData,
                        Province: this.cityData.provinceId
                    }
                }
                console.log('Aggiornamento dati città:', updateCityData)

                await this.$http.put(`cities/${this.cityData.id}`, updateCityData)

                // Preparazione dei sinonimi provincia
                const provinceSynonymData = this.provinceSynonyms.map((name) => ({
                    Name: name
                }))
                // Salvataggio dati della provincia
                const updateProvinceData = {
                    data: {
                        synonym: provinceSynonymData
                    }
                }
                // Aggiungi le coordinate provincia solo se sono presenti
                if (this.provinceData.latitude && this.provinceData.longitude) {
                    updateProvinceData.data.latitude = this.provinceData.latitude
                    updateProvinceData.data.longitude = this.provinceData.longitude
                }
                console.log('Aggiornamento dati provincia:', updateProvinceData)
                await this.$http.put(`provinces/${this.cityData.provinceId}`, updateProvinceData)
                this.$notify({
                    group: 'notifica',
                    title: 'Successo',
                    text: 'Dati salvati con successo',
                    type: 'success'
                })
                this.$router.push('/admin/updateCoordinates')
            } catch (error) {
                console.error('Errore nel salvataggio dei dati:', error)
                this.error = 'Errore nel salvataggio dei dati. Riprova più tardi.'
            } finally {
                this.loading = false
            }
        },

        // caricare i sinonimi della provincia
        async getProvinceDetails(provinceId) {
            try {
                const response = await this.$http.get(`provinces/${provinceId}`, {
                    populate: ['synonym']
                })

                const provinceData = response.data
                // Carica le coordinate
                this.provinceData = {
                    latitude: provinceData.attributes.latitude || null,
                    longitude: provinceData.attributes.longitude || null
                }

                // Gestione dei sinonimi provincia
                if (provinceData.attributes.synonym && provinceData.attributes.synonym.length > 0) {
                    this.provinceSynonyms = provinceData.attributes.synonym.map((s) => s.Name || '').filter(Boolean)
                } else {
                    this.provinceSynonyms = []
                }

                console.log('Dettagli provincia caricati:', {
                    coordinate: this.provinceData,
                    sinonimi: this.provinceSynonyms
                })
            } catch (error) {
                console.error('Errore nel caricamento dei sinonimi della provincia:', error)
                this.error = 'Errore nel caricamento dei sinonimi. Riprova più tardi.'
            }
        },

        async updateProvinceCoordinate() {
            this.loading = true
            this.error = null

            try {
                const requestData = {
                    city: this.cityData.province,
                    province: this.cityData.region,
                    country: this.countryName
                }
                console.log('--- PROVINCE COORDINATE REQUEST ---')
                console.log('Dati inviati a Google:', JSON.stringify(requestData, null, 2))
                console.log('Stringa che Google riceverà:', [requestData.city, requestData.province, requestData.country].filter(p => p && p.trim() !== '').join(' '))

                const res = await this.$http.post(`location`, {
                    type: 'addr',
                    data: requestData
                })

                console.log('Risposta da Google:', JSON.stringify(res, null, 2))

                if (res?.status == 'OK') {
                    console.log(`Coordinate provincia trovate: lat=${res.result.lat}, lng=${res.result.lng}`)
                    this.provinceData.latitude = res.result.lat.toString()
                    this.provinceData.longitude = res.result.lng.toString()

                    this.$notify({
                        group: 'notifica',
                        title: 'Successo',
                        text: 'Coordinate provincia aggiornate con successo',
                        type: 'success'
                    })
                } else {
                    this.error = "Coordinate provincia non trovate. Controlla l'indirizzo."
                }
            } catch (error) {
                console.error('Errore nel recupero delle coordinate provincia:', error)
                this.error = 'Errore nel recupero delle coordinate provincia. Riprova più tardi.'
            } finally {
                this.loading = false
            }
        },

        // Metodo per aggiungere un nuovo sinonimo
        addCitySynonym() {
            if (!this.newCitySynonym) return

            // Verifica se il sinonimo esiste già
            if (!this.cityData.synonym.includes(this.newCitySynonym)) {
                this.cityData.synonym.push(this.newCitySynonym)
                this.$notify({
                    group: 'notifica',
                    title: 'Successo',
                    text: 'Sinonimo aggiunto correttamente',
                    type: 'success'
                })
            } else {
                this.$notify({
                    group: 'notifica',
                    title: 'Attenzione',
                    text: 'Questo sinonimo è già presente',
                    type: 'warning'
                })
            }

            // Reset del campo
            this.newCitySynonym = ''
        },

        // Metodo per rimuovere un sinonimi
        removeCitySinonim(index) {
            // Crea una copia profonda dell'intero oggetto cityData
            const newCityData = JSON.parse(JSON.stringify(this.cityData))

            // Rimuovi il sinonimo dalla copia
            newCityData.synonym.splice(index, 1)

            // Sostituisci completamente l'oggetto cityData
            this.cityData = newCityData

            // Forza il rendering incrementando la chiave
            this.forceCityRenderKey++

            // Log per debug
            console.log('Sinonimi dopo la rimozione:', this.cityData.synonym)
            this.$notify({
                group: 'notifica',
                title: 'Successo',
                text: 'Sinonimo rimosso correttamente',
                type: 'success'
            })
        },
        // Metodo per aggiungere un nuovo sinonimo alla provincia
        addProvinceSynonym() {
            if (!this.newProvinceSynonym) return

            if (!this.provinceSynonyms.includes(this.newProvinceSynonym)) {
                this.provinceSynonyms.push(this.newProvinceSynonym)
                this.$notify({
                    group: 'notifica',
                    title: 'Successo',
                    text: 'Sinonimo provincia aggiunto correttamente',
                    type: 'success'
                })
            } else {
                this.$notify({
                    group: 'notifica',
                    title: 'Attenzione',
                    text: 'Questo sinonimo provincia è già presente',
                    type: 'warning'
                })
            }

            this.newProvinceSynonym = ''
        },
        // Metodo per rimuovere un sinonimo dalla provincia
        removeProvinceSynonym(index) {
            // Crea una copia dell'array dei sinonimi provincia
            const newProvinceSynonyms = [...this.provinceSynonyms]

            // Rimuovi il sinonimo
            newProvinceSynonyms.splice(index, 1)

            // Sostituisci l'array originale
            this.provinceSynonyms = newProvinceSynonyms

            // Forza il rendering incrementando la chiave
            this.provinceForceRenderKey++

            // Log per debug
            console.log('Sinonimi provincia dopo la rimozione:', this.provinceSynonyms)

            this.$notify({
                group: 'notifica',
                title: 'Successo',
                text: 'Sinonimo provincia rimosso correttamente',
                type: 'success'
            })
        },

        // Ricerca province per autocomplete
        async searchProvinces(val) {
            if (this.loadingProvinces) return
            this.loadingProvinces = true

            try {
                const response = await this.$http.get('provinces', {
                    'pagination[pageSize]': 50,
                    'filters[Name][$containsi]': val,
                    'sort': 'Name'
                })

                this.provinces = response.data.map((p) => ({
                    id: p.id,
                    name: p.attributes.Name,
                    region: p.attributes.Regione
                }))
            } catch (error) {
                console.error('Errore nella ricerca province:', error)
            } finally {
                this.loadingProvinces = false
            }
        },

        // Quando cambia la provincia selezionata
        onProvinceChange(province) {
            if (province) {
                this.cityData.province = province.name
                this.cityData.provinceId = province.id
                this.cityData.region = province.region

                // Carica i sinonimi della nuova provincia
                this.loadProvinceSynonyms(province.id)

                this.$notify({
                    group: 'notifica',
                    title: 'Provincia aggiornata',
                    text: `Provincia cambiata in ${province.name}`,
                    type: 'info'
                })
            }
        },

        // Carica sinonimi provincia
        async loadProvinceSynonyms(provinceId) {
            try {
                const response = await this.$http.get(`provinces/${provinceId}`, {
                    populate: ['synonym']
                })

                const provinceData = response.data
                if (provinceData.attributes.synonym && provinceData.attributes.synonym.length > 0) {
                    this.provinceSynonyms = provinceData.attributes.synonym.map((s) => s.Name || '').filter(Boolean)
                } else {
                    this.provinceSynonyms = []
                }

                // Aggiorna anche le coordinate provincia
                this.provinceData = {
                    latitude: provinceData.attributes.latitude || null,
                    longitude: provinceData.attributes.longitude || null
                }
            } catch (error) {
                console.error('Errore nel caricamento sinonimi provincia:', error)
            }
        },

        // Aggiungi CAP
        addCap() {
            if (!this.newCap) return

            // Verifica se il CAP esiste già
            if (!this.cityData.caps.includes(this.newCap)) {
                this.cityData.caps.push(this.newCap)
                this.$notify({
                    group: 'notifica',
                    title: 'Successo',
                    text: 'CAP aggiunto correttamente',
                    type: 'success'
                })
            } else {
                this.$notify({
                    group: 'notifica',
                    title: 'Attenzione',
                    text: 'Questo CAP è già presente',
                    type: 'warning'
                })
            }

            this.newCap = ''
        },

        // Rimuovi CAP
        removeCap(index) {
            this.cityData.caps.splice(index, 1)
            this.$notify({
                group: 'notifica',
                title: 'Successo',
                text: 'CAP rimosso correttamente',
                type: 'success'
            })
        }
    }
}
</script>
